<template>
  <div>
    <v-btn color="primary" @click="dialog = true">
      <v-icon>arrow_downward</v-icon>Download Chat</v-btn
    >
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title> Download Chat Data </v-card-title>
        <v-card-text>
          <v-menu
            ref="menuFrom"
            v-model="menuFrom"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <label for="">From</label>
              <v-text-field v-model="from" outline v-on="on"></v-text-field>
            </template>
            <v-date-picker
              v-model="from"
              no-title
              @input="menuFrom = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menuFrom"
            v-model="menuTo"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <label for="">To</label>
              <v-text-field v-model="to" outline v-on="on"></v-text-field>
            </template>
            <v-date-picker
              v-model="to"
              no-title
              @input="menuTo = false"
              :min="from"
            ></v-date-picker>
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="dialog = false"> Cancel </v-btn>
          <v-btn color="primary" :loading="loader" @click="downloadChat">
            Download
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import env from "../../../utils/env";
export default {
  name: "donwloadChat",
  data() {
    return {
      loader: false,
      dialog: false,
      menuFrom: "",
      menuTo: "",
      from: "",
      to: "",
    };
  },
  methods: {
    async downloadChat() {
      this.loader = true;

      if (!this.from || !this.to) {
        this.$store.dispatch("setSnackbar", {
          text: "Please select a date range",
          color: "error",
        });
        this.loader = false;
        return;
      }

      try {
        const blob = await this.$http_session_manager.get(
          `/bots/${this.$store.state.bot.botId}/download-all-chats`,
          {
            params: {
              from: this.from,
              to: this.to,
            },
            responseType: "blob",
            headers: {
              Accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
          }
        );
        // Automatically download the file
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "chats.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.log("Error downloading chat:", error);
        this.$store.dispatch("setSnackbar", {
          text: "Failed to download file",
          color: "error",
        });
      } finally {
        this.dialog = false;
        this.loader = false;
      }

    },
  },
};
</script>

<style scoped></style>
